import { toIsoDate } from 'utils';
import type { DateRange } from 'react-day-picker';

export enum TimeRange {
  Today = 'today',
  Yesterday = 'yesterday',
  ThisWeek = 'thisWeek',
  LastWeek = 'lastWeek',
  Custom = 'custom',
}

export enum Ordering {
  ZeitpunktDesc = '-zeitpunkt',
  ZeitpunktAsc = 'zeitpunkt',
  NameAsc = 'name',
  NameDesc = '-name',
  DauerAsc = 'dauer',
  DauerDesc = '-dauer',
}

export function getStartDate(dateRange?: DateRange): string {
  if (dateRange?.from) {
    return toIsoDate(dateRange.from);
  }
  return toIsoDate(new Date());
}

export function getEndDate(dateRange?: DateRange): string {
  const from = dateRange?.from;
  const to = dateRange?.to;

  if (to) {
    return toIsoDate(to);
  }
  if (from) {
    return toIsoDate(from);
  }
  return toIsoDate(new Date());
}
